/// <reference types="jasmine" />

import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MessageBusService } from './message-bus.service';

interface MessageBusEvent {
  eventName: string;
  eventBody: unknown;
}

export function spyOnMessageBusMethods(messageBus: MessageBusService): void {
  const eventSubject = new Subject<MessageBusEvent>();
  messageBus.getObservable = jasmine.createSpy('getObservable').and.callFake((eventName: string) =>
    eventSubject.pipe(
      filter((val) => val.eventName === eventName),
      map((data) => data.eventBody)
    )
  );
  messageBus.sendMessage = jasmine
    .createSpy('sendMessage')
    .and.callFake((eventName: string, eventBody: unknown) => eventSubject.next({ eventName, eventBody }));
}
